/**
 * cart-export.js — Sepeti "Fiyatlı Fiş" formatında GERÇEK Excel (.xlsx) olarak dışa aktarır.
 * Ürün görselleri dosyanın İÇİNE gömülür (ExcelJS), kutuya ortalanır ve tam sığar.
 *
 * Kolonlar: Görsel | Ürün | SKU | Set İçeriği | Sipariş Adedi | Ana Fiyat | Set Fiyatı | Toplam
 *   Ana = birim (tekli) fiyat | Set İçeriği = 1 setteki adet (canonical parser) | Set Fiyatı = Ana×Set İçeriği
 *   Sipariş Adedi = sepetteki toplam adet | Toplam = Ana×Sipariş Adedi
 *
 * PARA BİRİMİ: İki ayrı SAYFA (sekme) — "TL" ve "USD". Alttaki sekmeye tıklayarak geçilir; bu korumalı
 *   görünümde de çalışır ("Düzenlemeyi Etkinleştir" gerekmez). Her sayfa tek para birimi (karışıklık yok).
 *   USD kuru temanın döviz çeviricisinden okunur (.header__currency-option[data-currency="USD"] → data-rate).
 *   Görseller iki sayfada da aynı gömülü medyayı paylaşır (dosya şişmez).
 *
 * ExcelJS butona basınca lazy-yüklenir (asset URL: butonun data-exceljs-url'inden). cart-set-multiplier.js'e dokunmaz.
 */
(function () {
  'use strict';

  var BTN_ID = 'cart-export-excel';
  var productCache = {};

  function getUsdRate() {
    var rate = null;
    try {
      var el = document.querySelector('.header__currency-option[data-currency="USD"]');
      if (el) { var r = parseFloat(el.getAttribute('data-rate')); if (r > 0) rate = r; }
    } catch (e) {}
    return rate;
  }

  function setContentFor(handle, product) {
    if (productCache[handle] != null) return productCache[handle];
    var perSet = 1;
    try {
      if (window.ToserofSetParser && product) {
        var sizes = [];
        (product.variants || []).forEach(function (v) {
          (v.options || []).forEach(function (o) { if (o && sizes.indexOf(o) === -1) sizes.push(o); });
        });
        var r = window.ToserofSetParser.parse(product.description || '', sizes, product.title || '');
        if (r && r.found) {
          if (r.totalPerSet) perSet = r.totalPerSet;
          else if (r.multiplier) perSet = r.multiplier;
          else if (r.distributions) {
            var vals = Object.keys(r.distributions).map(function (k) { return r.distributions[k]; });
            perSet = vals.length ? Math.max.apply(null, vals) : 1;
          }
        }
      }
    } catch (e) {}
    if (!perSet || perSet < 1) perSet = 1;
    productCache[handle] = perSet;
    return perSet;
  }

  async function fetchProduct(handle) {
    try {
      var res = await fetch('/products/' + handle + '.js');
      if (!res.ok) return null;
      return await res.json();
    } catch (e) { return null; }
  }

  function imageToBase64(url) {
    return new Promise(function (resolve) {
      if (!url) return resolve(null);
      var src = url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=400';
      var im = new Image();
      im.crossOrigin = 'anonymous';
      im.onload = function () {
        try {
          // Uniform "cover" kırpma: tüm görseller aynı orana getirilir → kutuyu tam doldurur, hepsi aynı boy.
          var TW = 300, TH = 420;
          var cv = document.createElement('canvas');
          cv.width = TW; cv.height = TH;
          var ctx = cv.getContext('2d');
          ctx.fillStyle = '#ffffff'; ctx.fillRect(0, 0, TW, TH);
          var s = Math.max(TW / im.naturalWidth, TH / im.naturalHeight);
          var sw = im.naturalWidth * s, sh = im.naturalHeight * s;
          ctx.drawImage(im, (TW - sw) / 2, (TH - sh) / 2, sw, sh);
          resolve({ data: cv.toDataURL('image/jpeg', 0.85), w: TW, h: TH });
        } catch (e) { resolve(null); }
      };
      im.onerror = function () { resolve(null); };
      im.src = src;
    });
  }

  async function buildRows() {
    var res = await fetch('/cart.js');
    var cart = await res.json();
    if (!cart || !cart.items || !cart.items.length) return null;

    var groups = {}, order = [];
    cart.items.forEach(function (item) {
      var handle = item.handle || (item.url ? item.url.split('/products/')[1].split('?')[0] : null);
      if (!handle) handle = 'urun-' + item.product_id;
      if (!groups[handle]) {
        groups[handle] = {
          handle: handle,
          title: item.product_title || item.title || '',
          sku: item.sku || '',
          image: item.image || (item.featured_image && item.featured_image.url) || '',
          unitTl: (item.price || 0) / 100,
          qty: 0, lineTotalTl: 0
        };
        order.push(handle);
      }
      var g = groups[handle];
      g.qty += item.quantity || 0;
      g.lineTotalTl += (item.final_line_price != null ? item.final_line_price : (item.price * item.quantity)) / 100;
      if (!g.sku && item.sku) g.sku = item.sku;
    });

    await Promise.all(order.map(async function (handle) {
      var p = await fetchProduct(handle);
      groups[handle].perSet = setContentFor(handle, p);
      groups[handle].img64 = await imageToBase64(groups[handle].image);
    }));

    return order.map(function (h) { return groups[h]; });
  }

  function loadExcelJs(url) {
    return new Promise(function (resolve, reject) {
      if (window.ExcelJS) return resolve();
      if (!url) return reject(new Error('ExcelJS asset URL yok'));
      var s = document.createElement('script');
      s.src = url;
      s.onload = function () { window.ExcelJS ? resolve() : reject(new Error('ExcelJS yüklenemedi')); };
      s.onerror = function () { reject(new Error('ExcelJS indirilemedi')); };
      document.head.appendChild(s);
    });
  }

  // Görsel kutusu ölçüleri
  var IMG_COL_W = 16;   // ~117px
  var ROW_H = 120;      // pt ~160px
  var PAD = 8;          // görsel çevresi min boşluk (px) — cover kırpma ile kutu neredeyse tam dolar

  function buildSheet(wb, cur, rows, imgIds, usdRate, otherTab) {
    var ws = wb.addWorksheet(cur.code);

    var cols = [
      { w: IMG_COL_W, key: 'img', h: 'Görsel' },
      { w: 40, key: 'title', h: 'Ürün' },
      { w: 20, key: 'sku', h: 'SKU' },
      { w: 11, key: 'perSet', h: 'Set İçeriği' },
      { w: 13, key: 'qty', h: 'Sipariş Adedi' },
      { w: 16, key: 'ana', h: 'Ana Fiyat (' + cur.code + ')' },
      { w: 16, key: 'set', h: 'Set Fiyatı (' + cur.code + ')' },
      { w: 16, key: 'top', h: 'Toplam (' + cur.code + ')' }
    ];
    ws.columns = cols.map(function (c) { return { width: c.w }; });
    var nCol = cols.length;
    var lastColLetter = ws.getColumn(nCol).letter;

    function mergeRow(rowNum, text, font) {
      ws.mergeCells('A' + rowNum + ':' + lastColLetter + rowNum);
      var c = ws.getCell('A' + rowNum);
      c.value = text; c.font = font || {}; c.alignment = { vertical: 'middle' };
    }

    mergeRow(1, 'YAKE MALL — Sepet Çıktısı (Fiyatlı Fiş) — ' + cur.code, { bold: true, size: 15 });
    mergeRow(2, 'Ana Fiyat = birim (tekli) fiyat | Set İçeriği = 1 setteki adet | Set Fiyatı = Ana × Set İçeriği | Toplam = Ana × Sipariş Adedi', { size: 9, color: { argb: 'FF666666' } });
    var now = new Date();
    var dateStr = now.toLocaleDateString('tr-TR') + ' ' + now.toLocaleTimeString('tr-TR', { hour: '2-digit', minute: '2-digit' });
    var head3 = (cur.code === 'USD')
      ? ('Kur: 1 USD = ' + usdRate.toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' TRY   |   ' + dateStr)
      : ('Para birimi: TL   |   ' + dateStr);
    if (otherTab) head3 += '      ►  ' + cur.code + ' yerine ' + otherTab + ' fiyatlar için alttaki "' + otherTab + '" sekmesine tıklayın';
    mergeRow(3, head3, { size: 10, bold: true, color: { argb: 'FF1A5FB4' } });

    var HEAD_ROW = 4;
    var hr = ws.getRow(HEAD_ROW);
    cols.forEach(function (c, i) { hr.getCell(i + 1).value = c.h; });
    hr.eachCell(function (cell) {
      cell.font = { bold: true, color: { argb: 'FFFFFFFF' } };
      cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FF222222' } };
      cell.alignment = { vertical: 'middle', horizontal: 'left', wrapText: true };
      cell.border = { bottom: { style: 'thin', color: { argb: 'FF999999' } } };
    });
    hr.height = 26;

    var colPx = IMG_COL_W * 7 + 5;
    var rowPx = ROW_H * 4 / 3;
    var availW = colPx - PAD, availH = rowPx - PAD;
    var genel = 0;

    rows.forEach(function (r, i) {
      var rowNum = HEAD_ROW + 1 + i;
      var row = ws.getRow(rowNum);
      row.height = ROW_H;
      genel += r.lineTotalTl / cur.rate;

      row.getCell(2).value = r.title; row.getCell(2).alignment = { vertical: 'middle', wrapText: true };
      row.getCell(3).value = r.sku; row.getCell(3).alignment = { vertical: 'middle' };
      row.getCell(4).value = r.perSet; row.getCell(4).alignment = { horizontal: 'right', vertical: 'middle' };
      row.getCell(5).value = r.qty; row.getCell(5).alignment = { horizontal: 'right', vertical: 'middle' };
      [[6, r.unitTl], [7, r.unitTl * r.perSet], [8, r.lineTotalTl]].forEach(function (pair) {
        var cell = row.getCell(pair[0]);
        cell.value = Math.round((pair[1] / cur.rate) * 100) / 100;
        cell.numFmt = cur.fmt;
        cell.alignment = { horizontal: 'right', vertical: 'middle' };
      });
      row.eachCell(function (cell) { cell.border = Object.assign({ bottom: { style: 'hair', color: { argb: 'FFCCCCCC' } } }, cell.border || {}); });

      // Görseli kutuya ortalayarak ve GARANTİLİ boşlukla göm — asla taşmaz
      if (imgIds[i] != null && r.img64) {
        try {
          var scale = Math.min(availW / r.img64.w, availH / r.img64.h);
          var dispW = Math.max(1, Math.round(r.img64.w * scale));
          var dispH = Math.max(1, Math.round(r.img64.h * scale));
          var offX = Math.max(0, (colPx - dispW) / 2) / colPx;
          var offY = Math.max(0, (rowPx - dispH) / 2) / rowPx;
          ws.addImage(imgIds[i], { tl: { col: offX, row: (rowNum - 1) + offY }, ext: { width: dispW, height: dispH } });
        } catch (e) {}
      }
    });

    var totRow = HEAD_ROW + 1 + rows.length;
    var tr = ws.getRow(totRow);
    ws.mergeCells(tr.getCell(1).address + ':' + tr.getCell(nCol - 1).address);
    var lc = tr.getCell(1); lc.value = 'GENEL TOPLAM'; lc.font = { bold: true }; lc.alignment = { horizontal: 'right', vertical: 'middle' };
    var gcell = tr.getCell(nCol);
    gcell.value = Math.round(genel * 100) / 100; gcell.numFmt = cur.fmt; gcell.font = { bold: true }; gcell.alignment = { horizontal: 'right' };
  }

  async function buildWorkbook(rows, usdRate) {
    var wb = new ExcelJS.Workbook();
    // Görselleri bir kez ekle, tüm sayfalar paylaşsın
    var imgIds = rows.map(function (r) {
      if (r.img64 && r.img64.data) { try { return wb.addImage({ base64: r.img64.data, extension: 'jpeg' }); } catch (e) { return null; } }
      return null;
    });
    var currencies = [{ code: 'TL', rate: 1, fmt: '#,##0.00" ₺"' }];
    if (usdRate) currencies.push({ code: 'USD', rate: usdRate, fmt: '"$"#,##0.00' });
    currencies.forEach(function (cur) {
      var other = currencies.filter(function (c) { return c.code !== cur.code; }).map(function (c) { return c.code; })[0] || '';
      buildSheet(wb, cur, rows, imgIds, usdRate, other);
    });
    return wb;
  }

  function download(blob, name) {
    var url = URL.createObjectURL(blob);
    var a = document.createElement('a');
    a.href = url; a.download = name;
    document.body.appendChild(a); a.click();
    setTimeout(function () { document.body.removeChild(a); URL.revokeObjectURL(url); }, 800);
  }

  async function onExport(btn) {
    if (btn.dataset.busy === '1') return;
    btn.dataset.busy = '1';
    var original = btn.textContent;
    btn.disabled = true; btn.textContent = 'Hazırlanıyor…';
    try {
      await loadExcelJs(btn.getAttribute('data-exceljs-url'));
      var rows = await buildRows();
      if (!rows) { alert('Sepet boş.'); return; }
      var wb = await buildWorkbook(rows, getUsdRate());
      var buf = await wb.xlsx.writeBuffer();
      var d = new Date();
      var stamp = d.getFullYear() + '-' + ('0' + (d.getMonth() + 1)).slice(-2) + '-' + ('0' + d.getDate()).slice(-2);
      download(new Blob([buf], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }), 'Yakemall-Sepet-' + stamp + '.xlsx');
    } catch (e) {
      console.error('[Cart Export] hata:', e);
      alert('Dışa aktarma sırasında bir hata oluştu: ' + (e && e.message ? e.message : e));
    } finally {
      btn.textContent = original; btn.disabled = false; btn.dataset.busy = '0';
    }
  }

  function init() {
    var btn = document.getElementById(BTN_ID);
    if (!btn || btn.dataset.bound === '1') return;
    btn.dataset.bound = '1';
    btn.addEventListener('click', function (e) { e.preventDefault(); onExport(btn); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('cart:refresh', init);
  document.addEventListener('cart:updated', init);
})();
